import { useCallback, useEffect, useRef } from 'react';

export const useBlink = (delayMs: number, setValue: (v: boolean) => void) => {
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        return () => {
            if (timerRef.current != null) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return useCallback(
        (a: boolean, b: boolean) => {
            setValue(a);
            if (timerRef.current != null) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => setValue(b), delayMs);
        },
        [delayMs, setValue]
    );
};
